import React from 'react'
import { Box, Flex, Copy } from '@elparking/components'
import { FormattedMessage } from 'react-intl'
import Routes from 'commons/js/routes/routes'
import PropTypes from 'prop-types'
import CashbackIcon from '../Icons/Cashback'
import { TRADENAME } from 'commons/js/constants'
import styled from 'styled-components'
const Link = styled(Copy)`
    cursor: pointer;
`
const Cashback = ({cashbackInfoURL}) => <Flex mt='1em' backgroundColor='accent10' padding='0.5em'>
    <Box><CashbackIcon color='accent'/></Box>
    <Box ml='0.5em'>
        <Copy padding='0'><FormattedMessage defaultMessage='Recibe el 4% de Bonus en este alquiler de coche. Para no mutualistas te devolvemos un 2%.' /></Copy>
        <Copy mt='0.5em' fontWeight='regular' padding='0'><FormattedMessage defaultMessage='Recuerda el dinero aparecerá en tu monedero una vez que disfrutes tu alquiler en un plazo máximo de 24h para que lo uses en lo que quieras. Ahorra con {tradename}.' values={{tradename: TRADENAME}}/></Copy>
        <Link as='a' href={cashbackInfoURL} target='_blank' fontSize='xxSmall' fontColor='main' textDecoration='none' rel='noopener noreferrer'><FormattedMessage defaultMessage='Saber más'/></Link>
    </Box>
</Flex>

Cashback.propTypes = {
    cashbackInfoURL: PropTypes.string,
}

Cashback.defaultProps = {
    cashbackInfoURL: Routes.cashbackInfoURL(),
}
export default Cashback
